import React from "react";
import {Link} from "react-router-dom";
import {CgProfile} from "react-icons/cg";
import {getTexts} from "../index";

export default function Header() {
    const t = getTexts();

    return (
        <div className="top-bar">
            <div className="container-xl contents">
                <Link className="office-title" to="/">
                    {t.myOffice}
                </Link>
                <Link className="profile-link" to="/profile">
                    <CgProfile aria-hidden="true"/>
                    <span>{t.myProfile}</span>
                </Link>
            </div>
        </div>
    );
}
